import React from 'react';
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

const LoadingIndicator = ({ 
  message,
  size = 40, 
  open = true
}) => {
  return (
    (<Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.modal + 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.7)'
      }}
      open={open}
      // Verhindert das Schließen durch Klick
      onClick={(e) => e.stopPropagation()}
    >
      <CircularProgress 
        color="primary" 
        size={size} 
        thickness={4}
      />
      {message && (
        <Box sx={{
          mt: 2
        }}>
          <Typography variant="body1" sx={{
            color: "inherit"
          }}>
            {message}
          </Typography>
        </Box>
      )}
    </Backdrop>)
  );
};

export default LoadingIndicator; 